import flatpickr from "flatpickr";

export default function init() {
  const startDateDisable = [
    function (date) {
      // Disable dates in the past, but allow today
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const current = new Date(date);
      current.setHours(0, 0, 0, 0);
      return current < today;
    }
  ];
  const endDateDisable = [
    function (date) {
      // Disable dates in the past
      return date < new Date();
    },
  ];
  flatpickr("#start-date-input", {
    altInput: true,
    altFormat: "m/d/y",
    dateFormat: "Y-m-d",
    disableMobile: true,
    disable: startDateDisable,
    onChange: function (selectedDates, dateStr, instance) {
      if (selectedDates.length > 0) {
        document.getElementById("formatted-start-date").value =
          selectedDates[0].toISOString();
      }
      endDateDesktop.redraw(); // Redraw to update the end date picker
    },
  });
  const endDateDesktop = flatpickr("#end-date-input", {
    altInput: true,
    altFormat: "m/d/y",
    dateFormat: "Y-m-d",
    disableMobile: true,
    disable: endDateDisable.concat([
      function (date) {
        // Disable dates before or same to start date
        const startDate = document.getElementById("start-date-input").value; // Y-m-d
        if (startDate) {
          // Compare only the date parts (ignore time)
          // Parse startDate in "Y-m-d" format safely
          const [year, month, day] = startDate.split('-').map(Number);
          const start = new Date(year, month - 1, day);
          start.setHours(0, 0, 0, 0);
          const current = new Date(date);
          current.setHours(0, 0, 0, 0);
          return current < start || current.getTime() === start.getTime();
        }
        return false; // Allow all dates if no start date is selected
      },
    ]),
    onChange: function (selectedDates, dateStr, instance) {
      if (selectedDates.length > 0) {
        document.getElementById("formatted-end-date").value =
          selectedDates[0].toISOString();
      }
    },
  });

  flatpickr("#contact-us-input", {
    altInput: true,
    enableTime: true,
    dateFormat: "Y-m-d H:i",
    disableMobile: true,
  });
  flatpickr("#arrival", {
    altInput: true,
    enableTime: true,
    dateFormat: "Y-m-d",
    disableMobile: true,
  });
  flatpickr("#depature", {
    altInput: true,
    enableTime: true,
    dateFormat: "Y-m-d",
    disableMobile: true,
  });
  flatpickr("#mobile-start-date-search-input", {
    altInput: true,
    altFormat: "m/d/y",
    dateFormat: "Y-m-d",
    disableMobile: true,
    disable: endDateDisable.concat([
      function (date) {
        // Disable dates before the start date
        const startDate = document.getElementById("start-date-input").value;
        if (startDate) {
          // Compare only the date parts (ignore time)
          // Parse startDate in "Y-m-d" format safely
          const [year, month, day] = startDate.split('-').map(Number);
          const start = new Date(year, month - 1, day);
          start.setHours(0, 0, 0, 0);
          const current = new Date(date);
          current.setHours(0, 0, 0, 0);
          return current < start || current.getTime() === start.getTime();
        }
        return false; // Allow all dates if no start date is selected
      },
    ]),
    onChange: function (selectedDates, dateStr, instance) {
      if (selectedDates.length > 0) {
        document.getElementById("formatted-end-date").value =
          selectedDates[0].toISOString();
      }
      endDateMobile.redraw(); // Redraw to update the end date picker
    },
  });
  const endDateMobile = flatpickr("#mobile-end-date-search-input", {
    altInput: true,
    altFormat: "m/d/y",
    dateFormat: "Y-m-d",
    disableMobile: true,
    disable: endDateDisable.concat([
      function (date) {
        // Disable dates before the start date
        const startDate = document.getElementById("mobile-start-date-search-input").value;
        if (startDate) {
          // Compare only the date parts (ignore time)
          // Parse startDate in "Y-m-d" format safely
          const [year, month, day] = startDate.split('-').map(Number);
          const start = new Date(year, month - 1, day);
          start.setHours(0, 0, 0, 0);
          const current = new Date(date);
          current.setHours(0, 0, 0, 0);
          return current < start || current.getTime() === start.getTime();
        }
        return false; // Allow all dates if no start date is selected
      },
    ]),
    onChange: function (selectedDates, dateStr, instance) {
      if (selectedDates.length > 0 && document.getElementById("formatted-start-date")) {
        document.getElementById("formatted-start-date").value =
          selectedDates[0].toISOString();
      }
    },
  });

  function parseFlexibleDate(value) {
    if (!value) {
      return null;
    }
    const parsed = moment(
      value,
      [moment.ISO_8601, "YYYY-MM-DD", "MM/DD/YYYY", "M/D/YYYY", "MMMM D, YYYY", "MMM D, YYYY"],
      true
    );
    if (!parsed.isValid()) {
      return null;
    }
    return parsed.startOf("day");
  }

  function initDesktopHeaderDateDropdown() {
    const trigger = document.getElementById("tm-date-dropdown-trigger");
    const dateField = trigger ? trigger.closest(".tm-dates-field") : null;
    const panel = document.getElementById("tm-date-dropdown-panel");
    const display = document.getElementById("tm-date-dropdown-display");
    const inlineInput = document.getElementById("tm-date-range-inline-input");
    const startInput = document.getElementById("start-date-search-input");
    const endInput = document.getElementById("end-date-search-input");
    const startHidden = document.getElementById("formatted-start-date");
    const endHidden = document.getElementById("formatted-end-date");
    const applyBtn = document.getElementById("tm-date-apply-btn");
    const cancelBtn = document.getElementById("tm-date-cancel-btn");
    const resetBtn = document.getElementById("tm-date-reset-btn");

    if (
      !trigger ||
      !panel ||
      !display ||
      !inlineInput ||
      !startInput ||
      !endInput ||
      !startHidden ||
      !endHidden
    ) {
      return;
    }

    const closeHeaderSearchAutocomplete = () => {
      const jq = window.jQuery || window.$;
      if (!jq) {
        return;
      }

      const searchInput = jq("#desktop-name-search-input");
      if (searchInput.length && typeof searchInput.autocomplete === "function") {
        try {
          searchInput.autocomplete("close");
        } catch (error) {
          // no-op: autocomplete may not be initialized yet
        }
      }
      jq(".ui-autocomplete").hide();
    };

    const state = {
      appliedStart: parseFlexibleDate(startHidden.value),
      appliedEnd: parseFlexibleDate(endHidden.value),
      draftStart: null,
      draftEnd: null,
    };

    if (state.appliedStart && !state.appliedEnd) {
      state.appliedEnd = state.appliedStart.clone();
    }
    if (!state.appliedStart && state.appliedEnd) {
      state.appliedStart = state.appliedEnd.clone();
    }
    state.draftStart = state.appliedStart ? state.appliedStart.clone() : null;
    state.draftEnd = state.appliedEnd ? state.appliedEnd.clone() : null;

    const syncDisplayText = () => {
      const isMobileHeader = window.matchMedia("(max-width: 999px)").matches;

      if (!state.appliedStart || !state.appliedEnd) {
        display.textContent = "All Dates";
        if (dateField) {
          dateField.classList.remove("tm-date-has-value");
        }
        return;
      }

      if (dateField) {
        if (isMobileHeader) {
          dateField.classList.remove("tm-date-has-value");
        } else {
          dateField.classList.add("tm-date-has-value");
        }
      }

      if (state.appliedStart.isSame(state.appliedEnd, "day")) {
        display.textContent = state.appliedStart.format("MMM D, YYYY");
        return;
      }

      if (state.appliedStart.isSame(state.appliedEnd, "year")) {
        display.textContent =
          `${state.appliedStart.format("MMM D")} - ${state.appliedEnd.format("MMM D, YYYY")}`;
        return;
      }

      display.textContent =
        `${state.appliedStart.format("MMM D, YYYY")} - ${state.appliedEnd.format("MMM D, YYYY")}`;
    };

    const syncDateFieldModeForViewport = () => {
      syncDisplayText();
    };

    const syncInputValues = () => {
      startInput.value = state.draftStart ? state.draftStart.format("MM/DD/YYYY") : "";
      endInput.value = state.draftEnd ? state.draftEnd.format("MM/DD/YYYY") : "";
    };

    const syncHiddenValues = () => {
      startHidden.value = state.appliedStart ? state.appliedStart.toISOString() : "";
      endHidden.value = state.appliedEnd ? state.appliedEnd.toISOString() : "";
    };

    let picker = null;
    const isMobileHeaderViewport = () => window.matchMedia("(max-width: 999px)").matches;

    const fixCalendarGridLayout = (flatpickrInstance) => {
      if (!flatpickrInstance?.calendarContainer) {
        return;
      }

      const isMobile = isMobileHeaderViewport();

      window.requestAnimationFrame(() => {
        const daysContainer = flatpickrInstance.calendarContainer.querySelector(".flatpickr-days");
        if (daysContainer) {
          if (isMobile) {
            daysContainer.style.setProperty("display", "block", "important");
            daysContainer.style.setProperty("height", "auto", "important");
            daysContainer.style.setProperty("overflow", "visible", "important");
            daysContainer.style.setProperty("width", "100%", "important");
          } else {
            daysContainer.style.setProperty("display", "flex", "important");
            daysContainer.style.setProperty("width", "100%", "important");
          }
        }

        flatpickrInstance.calendarContainer.querySelectorAll(".dayContainer").forEach((container) => {
          container.style.setProperty("display", "grid", "important");
          container.style.setProperty("grid-template-columns", "repeat(7, minmax(0, 1fr))", "important");
          container.style.setProperty("justify-content", "stretch", "important");
          if (isMobile) {
            container.style.setProperty("flex", "none", "important");
            container.style.setProperty("max-width", "100%", "important");
            container.style.setProperty("width", "100%", "important");
          } else {
            container.style.setProperty("flex", "1 1 0", "important");
          }
        });

        if (!isMobile) {
          flatpickrInstance.calendarContainer.querySelectorAll(".flatpickr-weekdaycontainer").forEach((container) => {
            container.style.setProperty("display", "grid", "important");
            container.style.setProperty("grid-template-columns", "repeat(7, minmax(0, 1fr))", "important");
            container.style.setProperty("flex", "1 1 0", "important");
            container.style.setProperty("min-width", "0", "important");
          });
        }
      });
    };

    const decorateMobileMonthSections = (flatpickrInstance) => {
      if (!flatpickrInstance || !flatpickrInstance.calendarContainer || !isMobileHeaderViewport()) {
        return;
      }

      window.requestAnimationFrame(() => {
        const weekdayLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const monthBlocks = Array.from(
          flatpickrInstance.calendarContainer.querySelectorAll(".flatpickr-months .flatpickr-month")
        );
        const dayContainers = Array.from(
          flatpickrInstance.calendarContainer.querySelectorAll(".flatpickr-days .dayContainer")
        );

        dayContainers.forEach((container, index) => {
          const monthBlock = monthBlocks[index];
          if (!monthBlock) {
            return;
          }
          const monthName = (monthBlock.querySelector(".cur-month")?.textContent || "")
            .replace(/\s+/g, " ")
            .trim();
          const yearValue = monthBlock.querySelector(".cur-year")?.value || "";
          container.setAttribute("data-month-label", `${monthName} ${yearValue}`.trim());

          const existingWeekdays = container.querySelector(".tm-mobile-weekdays");
          if (existingWeekdays) {
            existingWeekdays.remove();
          }

          const weekdaysRow = document.createElement("div");
          weekdaysRow.className = "tm-mobile-weekdays";
          weekdayLabels.forEach((label) => {
            const dayLabel = document.createElement("span");
            dayLabel.textContent = label;
            weekdaysRow.appendChild(dayLabel);
          });
          container.insertBefore(weekdaysRow, container.firstChild);
        });
        fixCalendarGridLayout(flatpickrInstance);
      });
    };

    const getDesiredShowMonths = () => {
      return isMobileHeaderViewport() ? 18 : 2;
    };

    const ensurePicker = () => {
      const desiredShowMonths = getDesiredShowMonths();
      if (
        picker &&
        picker.config &&
        picker.config.showMonths === desiredShowMonths &&
        picker.calendarContainer &&
        picker.calendarContainer.offsetWidth > 10
      ) {
        return picker;
      }
      if (picker) {
        picker.destroy();
        picker = null;
      }
      picker = flatpickr("#tm-date-range-inline-input", {
        inline: true,
        mode: "range",
        showMonths: desiredShowMonths,
        dateFormat: "Y-m-d",
        disableMobile: true,
        minDate: "today",
        defaultDate: [
          state.draftStart ? state.draftStart.format("YYYY-MM-DD") : null,
          state.draftEnd ? state.draftEnd.format("YYYY-MM-DD") : null,
        ].filter(Boolean),
        onChange: function (selectedDates) {
          state.draftStart = selectedDates[0] ? moment(selectedDates[0]).startOf("day") : null;
          state.draftEnd = selectedDates[1] ? moment(selectedDates[1]).startOf("day") : null;
          syncInputValues();
          decorateMobileMonthSections(this);
          fixCalendarGridLayout(this);
        },
        onReady: function () {
          decorateMobileMonthSections(this);
          fixCalendarGridLayout(this);
        },
        onMonthChange: function () {
          decorateMobileMonthSections(this);
          fixCalendarGridLayout(this);
        },
        onYearChange: function () {
          decorateMobileMonthSections(this);
          fixCalendarGridLayout(this);
        },
      });
      return picker;
    };

    const syncPickerFromDraft = () => {
      const currentPicker = ensurePicker();
      const values = [
        state.draftStart ? state.draftStart.format("YYYY-MM-DD") : null,
        state.draftEnd ? state.draftEnd.format("YYYY-MM-DD") : null,
      ].filter(Boolean);
      if (values.length === 0) {
        currentPicker.clear(false);
        currentPicker.jumpToDate(new Date());
      } else {
        currentPicker.setDate(values, false);
        currentPicker.jumpToDate(values[0]);
      }
      currentPicker.redraw();
      syncInputValues();
      decorateMobileMonthSections(currentPicker);
      fixCalendarGridLayout(currentPicker);
    };

    const openPanel = () => {
      state.draftStart = state.appliedStart ? state.appliedStart.clone() : null;
      state.draftEnd = state.appliedEnd ? state.appliedEnd.clone() : null;
      if (document.activeElement && document.activeElement.id === "desktop-name-search-input") {
        document.activeElement.blur();
      }
      closeHeaderSearchAutocomplete();
      panel.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
      syncPickerFromDraft();
    };

    const closePanel = () => {
      panel.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
      closeHeaderSearchAutocomplete();
    };

    const applyDraft = () => {
      if (state.draftStart && !state.draftEnd) {
        state.draftEnd = state.draftStart.clone();
      }
      if (state.draftEnd && !state.draftStart) {
        state.draftStart = state.draftEnd.clone();
      }
      state.appliedStart = state.draftStart ? state.draftStart.clone() : null;
      state.appliedEnd = state.draftEnd ? state.draftEnd.clone() : null;
      syncHiddenValues();
      syncDisplayText();
      closePanel();

      const searchForm = trigger.closest("form");
      if (!searchForm) {
        return;
      }

      const jq = window.jQuery || window.$;
      if (jq) {
        jq(searchForm).trigger("submit");
        return;
      }

      if (typeof searchForm.requestSubmit === "function") {
        searchForm.requestSubmit();
      } else {
        searchForm.submit();
      }
    };

    const normalizeDraftFromInputs = () => {
      const typedStart = parseFlexibleDate(startInput.value);
      const typedEnd = parseFlexibleDate(endInput.value);
      state.draftStart = typedStart;
      state.draftEnd = typedEnd;
      if (state.draftStart && !state.draftEnd) {
        state.draftEnd = state.draftStart.clone();
      }
      if (state.draftEnd && !state.draftStart) {
        state.draftStart = state.draftEnd.clone();
      }
      if (state.draftStart && state.draftEnd && state.draftEnd.isBefore(state.draftStart)) {
        state.draftEnd = state.draftStart.clone();
      }
      syncPickerFromDraft();
    };

    trigger.addEventListener("click", function () {
      const isOpen = trigger.getAttribute("aria-expanded") === "true";
      if (isOpen) {
        closePanel();
      } else {
        openPanel();
      }
    });

    if (applyBtn) {
      applyBtn.addEventListener("click", function () {
        applyDraft();
      });
    }

    if (cancelBtn) {
      cancelBtn.addEventListener("click", function () {
        closePanel();
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener("click", function () {
        state.draftStart = null;
        state.draftEnd = null;
        state.appliedStart = null;
        state.appliedEnd = null;
        const currentPicker = ensurePicker();
        currentPicker.clear(false);
        currentPicker.jumpToDate(new Date());
        currentPicker.redraw();
        syncInputValues();
        syncHiddenValues();
        syncDisplayText();
        closePanel();
      });
    }

    startInput.addEventListener("blur", normalizeDraftFromInputs);
    endInput.addEventListener("blur", normalizeDraftFromInputs);

    document.addEventListener("click", function (event) {
      const isOpen = trigger.getAttribute("aria-expanded") === "true";
      if (!isOpen) {
        return;
      }
      if (!panel.contains(event.target) && !trigger.contains(event.target)) {
        closePanel();
      }
    });

    document.addEventListener("keydown", function (event) {
      const isOpen = trigger.getAttribute("aria-expanded") === "true";
      if (isOpen && event.key === "Escape") {
        closePanel();
      }
    });

    syncHiddenValues();
    syncDisplayText();
    syncInputValues();
    window.addEventListener("resize", syncDateFieldModeForViewport, { passive: true });
    window.addEventListener("orientationchange", syncDateFieldModeForViewport);
  }

  
  const page = window.location.pathname.split("/").pop();
  $("#desktop-search-form, #filters-search-form").on("submit", function (e) {
    e.preventDefault(); // Prevent the form from submitting normally

    // Serialize form data
    // Remove empty inputs before serializing
    $(this)
      .find("input, select, textarea")
      .filter(function () {
        return !this.value || this.value.trim() === "";
      })
      .prop("disabled", true);

    var formData = $(this).serialize();

    // Re-enable the inputs after serialization
    $(this).find("input, select, textarea").prop("disabled", false);
    // for checkboxes, we need to convert the values to an array
    formData = formData.replace(/category=([^&]*)/g, function (match, p1) {
      // if the value is not an array, we need to convert it to an array
      if (!Array.isArray(p1)) {
        // replace the spaces by dashes
        p1 = decodeURIComponent(p1).replace(/\s+/g, "-");
        return "category[]=" + encodeURIComponent(p1);
      }
      return match; // if it's already an array, return the original match
    });
    // also timeRange is a checkbox, so we need to convert it to an array
    formData = formData.replace(/timeRange=([^&]*)/g, function (match, p1) {
      // if the value is not an array, we need to convert it to an array
      if (!Array.isArray(p1)) {
        return "timeRange[]=" + encodeURIComponent(p1);
      }
      return match; // if it's already an array, return the original match
    });
    if (['shows', 'attractions', 'tours'].includes(page)) {
      //check if we don't have any category selected
      const categories = formData.match(/category\[\]=([^&]*)/g) || [];
      const params = new URLSearchParams(formData);
      const hasExplicitNonCategoryFilter = [
        "name",
        "startDate",
        "endDate",
        "minPrice",
        "maxPrice",
        "timeRange",
        "timeRange[]",
      ].some((key) =>
        params.getAll(key).some((value) => String(value ?? "").trim() !== "")
      );

      if (categories.length === 0 && !hasExplicitNonCategoryFilter) {
        // by default for shows
        let categories = [
          'adult-shows', 
          'comedy-shows', 
          'magic-shows', 
          'musical-shows', 
          'production-shows', 
          'tribute-shows',
        ];
        if (page === 'attractions') {
          categories = [
            'attractions',
            'concerts',
            'nightlife',
            'pop'
          ];
        } else if (page === 'tours') {
          categories = [
            'tours',
          ];
        }
        // add to the categories to the formData
        categories.forEach(category => {
          formData += `&category[]=${encodeURIComponent(category)}`;
        });
      }
    }
    // Set the serialized data in the URL
    const newUrl = window.location.origin + "/search" + "?" + formData;
    window.location.href = decodeURI(newUrl);
  });

  // now set the input values from the URL
  const urlParams = new URLSearchParams(window.location.search);
  // using the name of params in the URL, we can set the values of the inputs
  $("#desktop-search-form input, #filters-search-form input").each(function () {
    let name = $(this).attr("name");
    // category and timeRange are arrays, so add '[]' to the name
    if (name === "category" || name === "timeRange") {
      name += "[]";
    }
    if (urlParams.has(name)) {
      const values = urlParams.getAll(name).map(decodeURIComponent);
      if ($(this).is(":checkbox")) {
        // For checkboxes, check if the value matches any of the URL param values
        // for cagegories we need to replace dashes by spaces
        if (name === "category[]") {
          const formattedValues = values.map(value => value.replace(/-/g, " "));
          $(this).prop("checked", formattedValues.includes($(this).val()));
        } else {
          $(this).prop("checked", values.includes($(this).val()));
        }
      } else {
        if (name === "startDate" || name === "endDate") {
          $(this).val(moment(values[0]).format("YYYY-MM-DD"));
        } else {
          $(this).val(values[0]);
        }
      }
    }
  });

  initDesktopHeaderDateDropdown();

  $("#clear-filters-button").on("click", function () {
    $("#desktop-search-form, #filters-search-form").trigger("reset");
  });

  $(".search-tag-container").on("click", function (e) {
    try {
      var categoryName = $(e.currentTarget).text().toLowerCase().trim();
      var input = $(
        `input[type="checkbox"][name="category"][value="${categoryName.trim()}"]`
      ).first();
      input.prop("checked", true);
      document.getElementById("filters-search-form").submit();
    } catch (error) {
      console.log(error);
    }
  });

  $("#section-sort-search > select").change(function () {
    var selectedValue = $(this).val();
    var url = new URL(window.location.href);
    // when val is sequence, remove the sort parameter from the URL
    if (selectedValue === "sequence") {
      url.searchParams.delete("sort");
      url.searchParams.delete("sortDesc");
    }
    // when is price_l_h
    else if (selectedValue === "price_l_h") {
      url.searchParams.set("sort", "price_display");
      url.searchParams.set("sortDesc", "false");
    }
    // when is price_h_l
    else if (selectedValue === "price_h_l") {
      url.searchParams.set("sort", "price_display");
      url.searchParams.set("sortDesc", "true");
    }
    // when is name_a_z
    else if (selectedValue === "name_a_z") {
      url.searchParams.set("sort", "name");
      url.searchParams.set("sortDesc", "false");
    }
    // when is name_z_a
    else if (selectedValue === "name_z_a") {
      url.searchParams.set("sort", "name");
      url.searchParams.set("sortDesc", "true");
    }
    // now let's attached the new URL to the window location
    window.location.href = decodeURI(url.toString());
  });
  // when tha page load we need to set the value of the select
  const sortSelect = $("#section-sort-search > select");
  const sortValue = urlParams.get("sort");
  if (sortValue) {
    if (sortValue === "price_display") {
      var sortDesc = urlParams.get("sortDesc");
      if (sortDesc === "true") {
        sortSelect.val("price_h_l");
      } else {
        sortSelect.val("price_l_h");
      }
    } else if (sortValue === "name") {
      var sortDesc = urlParams.get("sortDesc");
      if (sortDesc === "true") {
        sortSelect.val("name_z_a");
      } else {
        sortSelect.val("name_a_z");
      }
    } else {
      sortSelect.val("sequence");
    }
  }
  // handle pagination
  handlePagination();
}

function handlePagination() {
  const defaultLimit = 8; // default limit for pagination
  // look for the limit in the URL
  const urlParams = new URLSearchParams(window.location.search);
  const limit = Number(urlParams.get("pagination")) || defaultLimit;
  const shows = $(".deal-card-container.search-card");
  // just hide the rest of the shows after the limit
  shows.each(function (index) {
    if (index >= limit) {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
  // if not there are shows hide let's remove the pagination button
  const showsNotVisible = $(".deal-card-container.search-card:hidden");
  if (showsNotVisible.length === 0) {
    $("#show-more-search").hide();
  }
  // let's handle the show more button
  $("#show-more-search")
    .off("click")
    .on("click", function () {
      const currentVisibleCount = $(".deal-card-container.search-card:visible").length;
      const nextLimit = parseInt(currentVisibleCount) + defaultLimit;
      shows.each(function (index) {
          $(this).show();        
      });
      // update the URL with the new limit
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("pagination", nextLimit);
      window.history.pushState({}, "", decodeURI(newUrl.toString()));
      // if we have shown all the shows, hide the button
      if ($(".deal-card-container.search-card:visible").length === shows.length) {
        $(this).hide();
      }
    });
}
